jQuery(document).ready(function($){


    //because fluid renders height attribiute for croped elements css is braking
    $('img').each(function() {
        $(this).removeAttr('width').removeAttr('height');
    });


    $('.c-text ul.c-item-list li a').each(function() {
        $(this).addClass('c-item-link  c-item-link__title').attr('data-icon', 'ui_external_link');
    });

});